import { Input } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './HomeAddressScreen.module.css';
import { TMobileSignupForm } from '../../form/form';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-689. Registration address — street / house number / postcode / town.
// Reads/writes the shared mobile signup form store (DIT-664). Matches the
// desktop AddressField fields + placeholders; the desktop street tooltip copy
// is promoted to the sub-heading here.
export const HomeAddressScreen = () => {
  const { t } = useLingui();
  const { register, watch } = useFormContext<TMobileSignupForm>();

  const street = watch('homeStreet');
  const houseNumber = watch('homeHouseNumber');
  const postcode = watch('homePostcode');
  const town = watch('homeTown');
  const isValid = Boolean(
    street.trim() && houseNumber.trim() && postcode.trim() && town.trim(),
  );

  return (
    <StepLayout
      stageTitle={t`Tell us about yourself`}
      heading={t`Your registration address`}
      subHeading={t`We need your current registration address as it appears on your ID.`}
      ctaDisabled={!isValid}
    >
      <div className={styles.fields}>
        <Input
          {...register('homeStreet')}
          label={t`Street`}
          placeholder={t`e.g. Street`}
          className="fs-mask"
        />
        <div className={styles.row}>
          <Input
            {...register('homeHouseNumber')}
            label={t`House number`}
            placeholder={t`e.g. 21`}
            inputMode="numeric"
            className="fs-mask"
          />
          <Input
            {...register('homePostcode')}
            label={t`Postcode`}
            placeholder={t`e.g. 37269`}
            inputMode="numeric"
            maxLength={5}
            className="fs-mask"
          />
        </div>
        <Input
          {...register('homeTown')}
          label={t`Town`}
          placeholder={t`e.g. London`}
          className="fs-mask"
        />
      </div>
    </StepLayout>
  );
};
